export default "__VITE_ASSET__CURDhrdc__";